define('view/module/ClientTermsView',['require','lib/view/LayoutView','lib/view/ModalRegion','view/controller/booking/details/DetailsLicenseView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ModalRegion = require('lib/view/ModalRegion');
    var DetailsLicenseView = require('view/controller/booking/details/DetailsLicenseView');

    return LayoutView.extend({

        template: '#client_terms_view',
        ui: {
            'simplybookTermsCheckbox': '#sb_simplybook_terms_flag',
            'userTermsCheckbox': '#sb_user_terms_flag',
            'privacyPolicyCheckbox': '#sb_privacy_policy_flag',
            'cancellationPolicyCheckbox': '#sb_cancellation_terms_flag',
            'promoLettersCheckbox': '#sb_promotion_letters_flag',
            'simplybookTerms': '#sb_simplybook_terms_link a, a#sb_simplybook_terms_link',
            'userTerms': '#sb_user_terms_link',
            'privacyPolicy': '#sb_privacy_policy_link',
            'cancellationPolicy': '#sb_cancellation_terms_link'
        },
        events: {
            'change @ui.simplybookTermsCheckbox': 'onChangeInput',
            'change @ui.userTermsCheckbox': 'onChangeInput',
            'change @ui.privacyPolicyCheckbox': 'onChangeInput',
            'change @ui.cancellationPolicyCheckbox': 'onChangeInput',
            'change @ui.promoLettersCheckbox': 'onChangeInput',
            'click @ui.simplybookTerms': 'showSimplybookTerms',
            'click @ui.userTerms': 'showUserTerms',
            'click @ui.privacyPolicy': 'showPrivacyPolicy',
            'click @ui.cancellationPolicy': 'showCancellationPolicy'
        },
        modelEvents: {
            'sync': 'render'
        },

        _cancellationPolicyModel: null,
        _userTermsAndConditionsModel: null,
        _termsAndConditionsModel: null,
        _privacyPolicyModel: null,

        initialize: function () {
            this._cancellationPolicyModel = this.getOption('cancellationPolicyModel');
            this._userTermsAndConditionsModel = this.getOption('userTermsAndConditionsModel');
            this._termsAndConditionsModel = this.getOption('termsAndConditionsModel');
            this._privacyPolicyModel = this.getOption('privacyPolicyModel');

            this.listenTo(this._cancellationPolicyModel, 'sync', this.render);
            this.listenTo(this._userTermsAndConditionsModel, 'sync', this.render);
            this.listenTo(this._termsAndConditionsModel, 'sync', this.render);
            this.listenTo(this._privacyPolicyModel, 'sync', this.render);
        },

        showSimplybookTerms: function (event) {
            event.preventDefault();

            this.showLicenseDialog(this._termsAndConditionsModel, null, 'simplybook_terms_flag');
        },

        showUserTerms: function (event) {
            event.preventDefault();

            this.showLicenseDialog(this._userTermsAndConditionsModel, '%company_name%_company_license_title', 'user_terms_flag');
        },

        showPrivacyPolicy: function (event) {
            event.preventDefault();

            this.showLicenseDialog(this._privacyPolicyModel, '%company_name%_privacy_policy_title', 'privacy_policy_flag');
        },

        showCancellationPolicy: function (event) {
            event.preventDefault();

            this.showLicenseDialog(this._cancellationPolicyModel, '%company_name%_cancellation_policy_title', 'cancellation_terms_flag');
        },

        showLicenseDialog: function (model, label, prop) {
            var region = new ModalRegion({
                closeOnBackdropClick: true
            });
            var view = new DetailsLicenseView({
                model: model,
                title: label
            });

            if (prop) {
                this.listenTo(view, 'confirm', _.bind(function () {
                    this.model.set(prop, true);
                    this.render();
                }, this));
            }

            region.show(view);
            return view;
        },

        onChangeInput: function (event) {
            var el = $(event.target);

            this.model.set(el.attr('name'), el.is(':checked'));
        },

        serializeData: function () {
            var company = Config.getInstance().getOption('company_data');
            var result = _.extend({
                'show_simplybook_terms': this.model.getTermsAndConditions().isSimplybookTermsAndConditionsVisible(),
                'show_user_terms': this.model.getTermsAndConditions().isUserTermsAndConditionsVisible(),
                'show_privacy_policy': this.model.getTermsAndConditions().isPrivacyPolicyVisible(),
                'show_cancellation_policy': this.model.getTermsAndConditions().isCancellationPolicyVisible(),
                'show_promotion_letter': this.model.getTermsAndConditions().isPromoLettersVisible(),
                'errors': this.model.validationError,
                'company': company.name,
                'server_address': Config.getInstance().getOption('server_address'),
                'project': Config.getInstance().getOption('project_name')
            }, LayoutView.prototype.serializeData.apply(this));

            if (this._cancellationPolicyModel) {
                result.cancellation_policy_label = this._cancellationPolicyModel.get('license_label');
            }

            return result;
        }

    });

});
